import { type Websocket } from 'entities/WebSocket'

interface IEventProfileProps {
  id: number | string
}

export class ChannelProfile {
  privateChannelName: string

  constructor(props: IEventProfileProps, private _websocket: Websocket) {
    this.privateChannelName = `private-profile.${props.id}`
    this.subscribe()
  }

  subscribe() {
    this._websocket.subscribe(this.privateChannelName)
  }
}
